module.exports = __webpack_public_path__ + "static/media/Mask.d3537d16.svg";